import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { NotificationIcon } from "./NotificationIcon";

const Header = ({ user, onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate("/login");
  };

  const getInitials = (email) =>
    email.split("@")[0].substring(0, 2).toUpperCase();

  const handleUserMenuToggle = () => {
    setShowDropdown((prev) => !prev);
    // 🔄 When user menu opens, close notification dropdown
    const notifDropdown = document.querySelector(".dropdown");
    if (notifDropdown) notifDropdown.style.display = "none";
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            <div className="logo-container">
              <img
                src="/bb-logo.png"
                alt="EQuAlly Logo"
                className="logo-image"
              />
              <h1>EQuAlly Admin</h1>
            </div>
          </Link>
        </div>

        <div className="header-right">
          <div className="user-menu">
            <div className="user-avatar" onClick={handleUserMenuToggle}>
              <span>{getInitials(user.email)}</span>
            </div>

            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-item user-info">
                  <strong>{user.email}</strong>
                  <small>Administrator</small>
                </div>
                <div className="dropdown-divider"></div>
                <button
                  className="dropdown-item logout-btn"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
          <NotificationIcon
            onToggle={(isOpen) => {
              if (isOpen) setShowDropdown(false);
            }}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
